import config from 'root/common/config/config';

export default {
    getSkuForm: `${config.privilegeApiDomain}/recharge/sku/v1/getSkuForm`,
    getRechargeSuccessAccount: `${config.privilegeApiDomain}/recharge/order/v1/successAccount`,
    hiddenSuccessAccount: `${config.privilegeApiDomain}/recharge/order/v1/hiddenSuccessAccount`,
};
